module.exports = __webpack_public_path__ + "b6a8dcb24d8d68eb1413ce431f90d169.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/grapplin-klaw-video-poster.jpg
// module id = 384
// module chunks = 0